// extracted by mini-css-extract-plugin
export var addOns = "pricing-module--addOns--d54df";
export var addOnsContainer = "pricing-module--addOnsContainer--05d70";
export var addOnsTitle = "pricing-module--addOnsTitle--9f147";
export var body = "pricing-module--body--ca3a0";
export var bottomCTAWrapper = "pricing-module--bottomCTAWrapper--c2b68";
export var bottomCta = "pricing-module--bottomCta--31a3f";
export var comparePlans = "pricing-module--comparePlans--8b5fd";
export var comparison = "pricing-module--comparison--f2f89";
export var comparisonCTA = "pricing-module--comparisonCTA--8936a";
export var cta = "pricing-module--cta--7af4f";
export var ctaContainer = "pricing-module--cta-container--176bf";
export var ctaSection = "pricing-module--ctaSection--2fb96";
export var ctaSectionButtons = "pricing-module--ctaSectionButtons--2085c";
export var ctaSectionTitle = "pricing-module--ctaSectionTitle--9883d";
export var eyebrow = "pricing-module--eyebrow--c86b1";
export var faq = "pricing-module--faq--83778";
export var header = "pricing-module--header--75973";
export var headerSubline = "pricing-module--headerSubline--3d036";
export var plans = "pricing-module--plans--bb5a4";
export var plansInner = "pricing-module--plansInner--9186c";
export var ratingsContainer = "pricing-module--ratings-container--c8e94";
export var ratingsSubtitle = "pricing-module--ratingsSubtitle--de3a7";
export var ratingsTitle = "pricing-module--ratingsTitle--17123";
export var ratingsTitleContainer = "pricing-module--ratingsTitleContainer--986f1";
export var topBgCtn = "pricing-module--topBgCtn--64e75";